import React, { Fragment, useEffect } from 'react';
import './modal.css';
import { useAuth } from '../AuthProvider';
import Spinner from '../components/reusable/Spinner';
import { Tooltip } from '@mui/material';


const Modal = ({
    close,
    loading,
    disableDefaultButton,
    fieldsLoading,
    headerText,
    subHeaderText,
    cancelText,
    submitText,
    blockText,
    alignment,
    isView,
    defaultText,
    defaultHandler,
    submitHandler,
    customStyles,
    children,
    disable,
    icon = null,
    discription
}) => {
    const { lang } = useAuth();

    useEffect(() => {
        const handler = (e) => e.key === 'Escape' && close();
        document.addEventListener('keydown', handler);

        return () => document.removeEventListener('keydown', handler);
    }, [close]);

    return (
        <div id='modal'>
            <div id='popup' style={{
                animation: `zoom-${lang} .4s linear`,
                direction: alignment ? 'ltr' : 'rtl',
                ...customStyles
            }}>
                <div className='modal-main-container' style={{ padding: 0 }}>
                    <div className='modal-header'>
                        <div className='modal-header-item'>
                            {icon && <div className='modal-header-icon'>{icon}</div>}
                            <h2>{headerText}</h2>
                        </div>
                        {!loading && subHeaderText ? <p>{subHeaderText}</p> : null}
                    </div>
                    {discription ? <p style={{
                        padding:'0 3.4rem'
                    }}>{discription}</p> : null}

                    <div  className='separator' style={{ margin: '1.5rem 0' }}></div>
                    {/* <DndProvider backend={HTML5Backend}> */}
                        <div
                            id='scroll-container'
                            className='modal-content'
                            style={{ textAlign: alignment ? 'left' : 'right', position: 'relative', backgroundColor: 'transparent' }}>
                            {fieldsLoading && <div className='modal-loading' style={{ top: document.getElementById('scroll-container')?.scrollTop || 0 }}>
                                <span className='loading-text'>Loading...</span>
                            </div>}
                            {loading ? (
                                <Spinner />
                            ) : (
                                children
                            )}
                        </div>
                    {/* </DndProvider> */}
                    <div className='modal-footer' style={{ flexDirection: alignment ? '' : 'row-reverse' }}>
                        {!loading
                            ? <Fragment>
                                {/* {user.role === 'Admin' && !disableDefaultButton
                                    ? <button
                                        className='modal-btn modal-cancel-btn'
                                        onClick={defaultHandler}>
                                        {defaultText}
                                    </button>
                                    : <div></div>} */}
                                <div className='settings-row-action' style={{ ...{ flexDirection: alignment ? '' : 'row-reverse' }, gap: '0.75rem' }}>
                                    <button className='modal-btn modal-cancel-btn' onClick={close}>{cancelText}</button>
                                    {!isView
                                        ? <Tooltip
                                            title={disable ? blockText : ''}
                                            placement={alignment ? 'top-start' : 'top-end'}>
                                            <button
                                                className={`modal-btn modal-add-btn ${disable ? 'disabled' : ''}`}
                                                onClick={disable ? null : submitHandler}>
                                                {submitText}
                                            </button>
                                        </Tooltip>
                                        : null}
                                </div>
                            </Fragment>
                            : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
